import { isNativeApp } from '@/utils/native-platform'
import { persistentStorage } from '@/services/persistent-storage'

const COOKIE_NAME = import.meta.env.VITE_AUTH_TOKEN_KEY || `auth_token`
const NATIVE_STORAGE_KEY = `auth_token`
const COOKIE_DOMAIN = import.meta.env.VITE_AUTH_TOKEN_DOMAIN

function escapeForRegExp(value: string) {
  return value.replace(/([.$?*|{}()[\]\\/+^])/g, `\\$1`)
}

function getAuthToken() {
  if (isNativeApp()) {
    return persistentStorage.getItem(NATIVE_STORAGE_KEY) ?? undefined
  }

  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${escapeForRegExp(COOKIE_NAME)}=([^;]*)`)
  )
  return matches ? decodeURIComponent(matches[1]) : undefined
}

// 1 year, matching the JWT's own validity (config.jwt.expiration_time in
// plentify's devise.rb) and the legacy flow's Set-Cookie expiry
// (ApplicationController#cookie_base) - the same token is minted either way,
// so the client-set cookie should outlive it for exactly as long.
const AUTH_TOKEN_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

function setAuthToken(token: string) {
  if (isNativeApp()) {
    persistentStorage.setItem(NATIVE_STORAGE_KEY, token)
    return
  }

  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(token)}; path=/; max-age=${AUTH_TOKEN_MAX_AGE_SECONDS}`
}

function clearAuthToken() {
  if (isNativeApp()) {
    persistentStorage.removeItem(NATIVE_STORAGE_KEY)
    return
  }

  const expiry = `${COOKIE_NAME}=; path=/; max-age=0`
  document.cookie = expiry
  if (COOKIE_DOMAIN) {
    document.cookie = `${expiry}; domain=${COOKIE_DOMAIN}`
  }
}

export { getAuthToken, setAuthToken, clearAuthToken }
